var __default__ = {root:'m_f0824112',description:'m_57492dcc',section:'m_690090b5',label:'m_1f6ac4c4',body:'m_f07af9d2',children:'m_e17b862f',chevron:'m_1fd8a00b'};
export default __default__;